import CustomerService from '_services/rest/modules/customer';
import { CONTACT, ADDRESS } from './components/CustomerModel';

export default {
  state: {
    customer: null,
    customerList: null,
    fileList: null,
    tempFiles: [],
  },
  mutations: {
    setCustomerList(state, response) {
      state.customerList = response;
    },
    setCustomer(state, response) {
      state.customer = response;
      state.type = response.type || 'individual';
    },
    setCustomerAddress(state, addresses) {
      if (addresses.length > 0) {
        addresses.forEach(address => {
          if (address.address) {
            const [street, number] = address.address.split(', ');
            address.street = street;
            address.number = number;
          }
        });
        state.customer.addresses = addresses;
        return;
      }
      state.customer.addresses = [{ ...ADDRESS }];
    },
    setCustomerContact(state, contacts) {
      if (contacts) {
        state.customer.contact = contacts;
        return;
      }
      state.customer.contact = { ...CONTACT };
    },
    setFile(state, response) {
      state.fileList = response;
    },
    setTempFiles(state, files) {
      state.tempFiles = files;
    },
  },
  actions: {
    getCustomerList({ commit }, params) {
      return CustomerService.getList(params)
        .then(response => {
          commit('setCustomerList', response);
        });
    },
    getCustomer({ commit }, params) {
      return CustomerService.getCustomerById(params)
        .then(response => {
          const customer = response;
          commit('setCustomer', customer);
          commit('setCustomerAddress', customer.addresses);
          commit('setCustomerContact', customer.contact);
        });
    },
    getCustomerAddress({ commit }, addresses) {
      commit('setCustomerAddress', addresses);
    },
    getFiles({ commit }, params) {
      return CustomerService.getFiles(params)
        .then(response => {
          commit('setFile', response);
        });
    },
    setTempFiles({ commit }, files) {
      commit('setTempFiles', files);
      commit('setFile', files);
    },
    deleteTempFile({ commit, state }, index) {
      if (state.tempFiles && state.tempFiles.length > 0) {
        const tempFiles = [...state.tempFiles];
        tempFiles.splice(index, 1);
        commit('setTempFiles', tempFiles);
      }
    },
    clearTempFiles({ commit }) {
      commit('setTempFiles', []);
    },
  },
};
